import { getIconAsSvgString } from "./icon.js";
const clusterSizes = [
  {
    width: 24,
    height: 25
  },
  {
    width: 41,
    height: 42
  },
  {
    width: 56,
    height: 58
  },
  {
    width: 72,
    height: 74
  },
  {
    width: 88,
    height: 90
  }
];
const markerClusterStyles = ({ theme, size }) => {
  const textSize = 12;
  const height = size.height;
  const width = size.width;
  const color = theme.color;
  const textColor = theme.textColor;
  const svgString = getIconAsSvgString(width, height, color, textColor);
  return {
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
    width,
    height,
    textColor,
    textSize
  };
};
const MarkerClusters = (props) => {
  const { theme, maxZoom = 10, minimumClusterSize = 2 } = props;
  const styles = clusterSizes.map(
    (clusterSize) => markerClusterStyles({ size: clusterSize, theme })
  );
  return {
    styles,
    maxZoom,
    minimumClusterSize
  };
};
export {
  MarkerClusters,
  clusterSizes
};
//# sourceMappingURL=MarkerClusters.js.map
